import React, { useReducer } from "react";
import { ServiceContext } from "../Contexts.js";
import serviceReducer from "./ServicesReducer.js";

const ServiceState = (props) => {
  const initialState = {
    services: [
      {
        title: "TMJ Massage",
        description:
          "A focused treatment targeting the neck, jaw & face to relieve pain and tension from Temporomandibular Joint (TMJ) dysfunction. Ideal for reducing jaw pain, headaches & tension caused by clenching, grinding &/or stress.",
        price30: null,
        price60: 115,
        price90: 172,
        price120: 230,
      },
      {
        title: "Swedish",
        description:
          "Relaxing, gentle massage that promotes overall wellness and reduces stress.",
        price30: 45,
        price60: 90,
        price90: 135,
        price120: 180,
      },
      {
        title: "Deep Tissue",
        description:
          "Focused on relieving tension in deeper muscle layers for chronic pain relief.",
        price30: 45,
        price60: 90,
        price90: 135,
        price120: 180,
      },
      {
        title: "Prenatal",
        description:
          "Tailored for expectant mothers to ease discomfort and promote relaxation.",
        price30: 47,
        price60: 94,
        price90: 141,
        price120: 188,
      },
      {
        title: "Lymphatic Wellness",
        description:
          "Gentle massage to encourage lymphatic drainage and boost the immune system.",
        price30: 47,
        price60: 94,
        price90: 141,
        price120: 188,
      },
      {
        title: "Sports Massage",
        description:
          "Targeted therapy for athletes, improving flexibility, performance, and recovery.",
        price30: 50,
        price60: 100,
        price90: 150,
        price120: 200,
      },
      {
        title: "Stretching",
        description:
          "Assisted stretching to enhance flexibility, mobility, and muscle recovery.",
        price30: 45,
        price60: 90,
        price90: 135,
        price120: 180,
      },
      {
        title: "Reiki",
        description:
          "Energy healing technique to balance the body's energy and promote emotional well-being.",
        price30: 50,
        price60: 100,
        price90: 150,
        price120: 200,
      },
      {
        title: "Reiki + Massage",
        description:
          "Combines the healing touch of massage with the balancing effects of Reiki.",
        price30: 50,
        price60: 100,
        price90: 150,
        price120: 200,
      },
      {
        title: "Couples Massage",
        description:
          "Allows partners to enjoy side-by-side massages in a peaceful environment.",
        price30: 94,
        price60: 188,
        price90: 282,
        price120: 375,
      },
      {
        title: "Therapeutic Massage",
        description:
          "A targeted massage to relieve tension, reduce pain, and restore balance, tailored to your unique needs for enhanced well-being.",
        price30: 47,
        price60: 94,
        price90: 141,
        price120: 188,
      },
      {
        title: "Post-Op Lymphatic Drainage",
        description:
          "Reduce swelling, prevent fibrosis, and speed up recovery with gentle, targeted techniques. Our experienced therapists support your healing journey with personalized care in a tranquil, supportive environment.",
        price30: 55,
        price60: 110,
        price90: 165,
        price120: 220,
      },
      {
        title: "Pre-Op Lymphatic Drainage",
        description:
          "Prepare your body for surgery with gentle lymphatic techniques that reduce fluid retention, boost circulation, and support your immune system. Personalized care to promote optimal surgical outcomes.",
        price30: 47,
        price60: 94,
        price90: 141,
        price120: 188,
      },
      {
        title: "Sugar Scrub",
        description:
          "A full body scrub using relaxing massage techniques to relax, exfoliate, remove impurities, and brighten the skin. ",
        price30: null,
        price60: 110,
        price90: 165,
        price120: 220,
      },
    ],
    addons: [
      {
        title: "Anti-inflammatory Oil",
        description:
          "Infuses massage with a hemp-derived oil to reduce inflammation and promote deep relaxation.",
        price: 20,
      },
      {
        title: "Radio Frequency (RF) therapy",
        description:
          "Boost your post-surgical recovery with our Radio Frequency (RF) therapy, designed to enhance lymphatic services. RF stimulates collagen, tightens skin, and reduces swelling, improving circulation and promoting faster healing. Must be 6-8 weeks post-op to add this service. Always consult your doctor first. Experience smoother, firmer skin and a quicker recovery with RF treatment.",
        price: 25,
      },
      {
        title: "Steam Eye Mask",
        description:
          "Enhance your massage with our unscented steam eye mask, offering 30–40 minutes of soothing warmth to relieve stress, eye fatigue, dry eyes, and more. This disposable mask promotes deep relaxation, reduces dark circles and fine lines, and complements your wellness experience. Note: Not for use with contact lenses.",
        price: 10,
      },
      {
        title: "Cooling Muscle Balm",
        description: "Cooling therapy to relieve muscle pain and soreness.",
        price: 15,
      },
      {
        title: "Cupping",
        description:
          "Traditional therapy using suction cups to improve circulation and relieve muscle tension.",
        price: 20,
      },
      {
        title: "Hot Stones",
        description:
          "Warm stones are used to deeply relax muscles and enhance the massage experience.",
        price: 20,
      },
      {
        title: "Hyaluronic Acid Eye Mask",
        description:
          "Enhance your massage with our Hyaluronic Acid Eye Mask. It hydrates, reduces puffiness, and helps diminish dark circles, all while you relax and unwind during your massage. ",
        price: 10,
      },
      {
        title: "Magnesium",
        description:
          "Applied during massage to soothe muscle aches/spasms and improve skin health. Upon initial use, some people experience some mild tingling, similar to the sensation of salty ocean water which quickly subsides.",
        price: 15,
      },
      {
        title: "Red Light Therapy",
        description:
          "Stimulates collagen production, reduces inflammation, and promotes skin healing and cellular regeneration.",
        price: 15,
      },
      {
        title: "Sugar Scrub for Hands & Feet",
        description:
          "This sugar scrub for hands and feet exfoliates the skin, enhances circulation, and provides deep hydration, leaving the skin soft, rejuvenated, and nourished.",
        price: 15,
      },
      {
        title: "Scalp Treatment",
        description:
          "Relaxing scalp treatment using nourishing coconut oil for hydration.",
        price: 10,
      },
      {
        title: "Scalp Treatment + Rosemary",
        description:
          "Revitalizing treatment that hydrates, enhances circulation, and promotes hair health.",
        price: 15,
      },
      {
        title: "Scalp Treatment + Peppermint",
        description:
          "Refreshing massage that soothes tension, stimulates blood flow, and cools the scalp.",
        price: 15,
      },
      {
        title: "Hot/Cold Contrast Therapy",
        description:
          "Alternating heat and cold applications to reduce inflammation, ease pain, and accelerate recovery.",
        price: 15,
      },
      {
        title: "Cold Stone Facial Massage",
        description:
          "This cooling treatment uses chilled stones to calm inflammation, reduce puffiness, and tighten the skin, leaving your face feeling refreshed and revitalized.",
        price: 10,
      },
      {
        title: "Facial Cupping",
        description:
          "Facial cupping gently lifts the skin with small cups to increase blood flow, stimulate collagen production, and promote a youthful, smooth appearance.",
        price: 10,
      },
      {
        title: "Facial Gua Sha",
        description:
          "A more targeted version of gua sha, this treatment focuses on facial contours to release facial tension, improve circulation, and enhance the natural radiance of your skin.",
        price: 10,
      },
      {
        title: "Facial Red Light Therapy",
        description:
          "Red light therapy utilizes specific wavelengths of light to penetrate deep into the skin, stimulating collagen production, reducing fine lines, and improving skin tone and texture for a radiant glow.",
        price: 10,
      },
      {
        title: "Reflexology - 15 Minutes",
        description:
          "Reflexology is a therapeutic technique that applies pressure to specific points on the feet, hands, or ears, corresponding to different body organs and systems. This holistic approach promotes relaxation, relieves tension, and enhances overall well-being by stimulating the body's natural healing processes.",
        price: 30,
      },
      {
        title: "Aromatherapy",
        description:
          "Aromatherapy uses essential oils to enhance relaxation and well-being.",
        price: 5,
        options: [
          {
            title: "Lavender",
            description:
              "Soothes the nervous system, reduces stress, and supports restful sleep with its calming floral notes.",
          },
          {
            title: "Eucalyptus",
            description:
              "Clears mental fog, supports respiratory health, and revitalizes tired muscles with its crisp, cooling scent.",
          },
          {
            title: "Peppermint",
            description:
              "Sharpens focus, relieves headaches, and cools the body with its crisp, refreshing effect.",
          },
          {
            title: "Lemongrass",
            description:
              "Soothes muscle tension, encourages circulation, and refreshes the spirit with its bold, zesty aroma.",
          },
          {
            title: "Clary Sage",
            description:
              "Balances emotions, promotes relaxation, and eases stress with its soothing, herbal fragrance.",
          },
          {
            title: "Frankincense",
            description:
              "Promotes inner peace, supports healthy skin, and enhances focus with its warm, grounding essence.",
          },
          {
            title: "Grapefruit",
            description:
              "Helps regulate blood pressure, boosts metabolism, and uplifts mood with its bright, energizing aroma.",
          },
          {
            title: "Lemon",
            description:
              "Aids in detoxification, balances pH levels, and invigorates energy with its fresh, clean citrus essence. ",
          },
          {
            title: "Rosemary",
            description:
              "Stimulates hair growth, boosts circulation, and enhances focus with its invigorating herbal scent.",
          },
          {
            title: "Sweet Orange",
            description:
              "Uplifts mood, strengthens the immune system, and fosters positivity with its cheerful, sweet fragrance.",
          },
        ],
      },
    ],
    waxes: [
      {
        title: "Brazilian",
        price: 60
      },
      {
        title: "Eyebrow",
        price: 20
      },
      {
        title: "Lower Legs (Knee to Ankle)",
        price: 40
      },
      {
        title: "Full Legs (Thigh to Ankle)",
        price: 80
      },
      {
        title: "Underarm",
        price: 15
      },
      {
        title: "Intimate Brightening Treatment (Women Only)",
        price: 75
      },
      {
        title: "Full Arm (Not Including Underarms)",
        price: 90
      },
      {
        title: "Stomach",
        price: 45
      },
      {
        title: "Lower Arms",
        price: 45
      },
      {
        title: "Full Back",
        price: 80
      }
    ]
  };

  const [state, dispatch] = useReducer(serviceReducer, initialState);

  // Load Services
  const loadServices = async () => {
    await dispatch({
      type: "SERVICES_LOADED",
      payload: initialState.services,
    });
  };

  // Load Addons
  const loadAddons = async () => {
    await dispatch({
      type: "ADDONS_LOADED",
      payload: initialState.addons,
    });
  };

  // Load Waxes
  const loadWaxes = async () => {
    await dispatch({
      type: "WAXES_LOADED",
      payload: initialState.waxes,
    });
  }

  return (
    <ServiceContext.Provider
      value={{
        services: state.services,
        loadServices,
        addons: state.addons,
        loadAddons,
        waxes: state.waxes,
        loadWaxes,
      }}
    >
      {props.children}
    </ServiceContext.Provider>
  );
};

export default ServiceState;
